// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"7c450ab6951c4004c549","111":"aad32e410ab1a3291828","112":"3c8e9bc8d0085277284f","159":"0fd2348f79beb5b05fa8"}[chunkId] + ".chunk.js";
};